import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{class:_vm.classes,attrs:{"id":"inspire"}},[_c('rcc-sidebar',{attrs:{"isOpen":_vm.isDrawerOpen}}),_c('rcc-header',{ref:"headerRef",on:{"clickToDrawerIcon":function($event){_vm.isDrawerOpen = !_vm.isDrawerOpen}}}),_c(VMain,[_c(VContainer,{attrs:{"id":"main-content"}},[_c('router-view')],1)],1),_c('rcc-loading-overlay'),_c('rcc-snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }